const profiles = {
  header: {
    btnCreate: 'Crear',
  },

  toast: {
    error: {
      badResponse: '[Perfil] respuesta incorrecta del servidor',
      create: {},
      edit: {},
    },
    success: {
      create: {},
      edit: {},
      delete: {
        body: 'Los perfiles se eliminaron correctamente',
      },
    },
  },
  table: {
    headers: {
      name: 'Nombre',
      email: 'Correo electrónico',
      phone: 'Telefono',
    },
    actions: {
      delete: 'Eliminar',
      export: 'Exportar',
    },
    toolTip: {
      noPermission: 'Action not allowed: Permission required',
    },
  },
  forms: {
    header: {
      createProfile: {
        title: 'Crear',
      },

      updateProfile: {
        title: 'Actualizar',
      },
    },

    footer: {
      confirmButtonText: {
        create: 'Enviar',
        update: 'Enviar',
      },
    },

    general: {
      header: 'General',
      fields: {
        profileType: {
          label: 'Tipo de perfil',
          options: {
            retail: 'Minorista',
            individual: 'Individual',
            wholesale: 'Al por mayor',
            corporate: 'Corporativo',
            web: 'Web',
            hotel: 'Hotel',
            thirdParty: 'Tercero',
            tourOperator: 'Operador de Turno',
            receiptiveOperator: 'Operador de recepción',
          },
        },
        rateType: {
          label: 'Tipo de tarifa',
          options: {
            connections: 'Conexiones',
            corporate: 'Tasa de empresa',
            expedia: 'Expedición',
            groundTransportation: 'Transporte Terrestre',
            holidayTaxis: 'Taxis de vacaciones',
            respectiveOperator: 'Tasa de operador respectivo',
            retail: 'Tasa Reatil',
            tourOperator: 'Tarifa de operador de viaje',
            viator: 'Viator',
          },
        },
        name: {
          label: 'Nombre',
        },
        status: {
          label: 'Estado',
          options: {
            active: 'Activo',
            inactive: 'Inactiva',
            onHold: 'En espera',
          },
        },
        email: {
          label: 'Dirección de correo electrónico',
        },
        startDate: {
          label: 'Fecha de inicio',
        },
        phone: {
          label: 'Número de teléfono',
        },
        additionalPhone: {
          label: 'Teléfono adicional',
        },
        fax: {
          label: 'Número de fax',
        },
        attributes: {
          label: 'Atributos',
        },
      },
    },
    billing: {
      header: 'Información de facturación',
      fields: {
        name: {
          label: 'Nombre de facturación',
        },
        email: {
          label: 'Dirección de correo electrónico',
        },
        phone: {
          label: 'NÚMERO DE TELÉFONO',
        },
        address: {
          label: 'Dirección',
        },
        city: {
          label: 'Ciudad',
        },
        state: {
          label: 'Estado',
        },
        zip: {
          label: 'Código postal',
        },
        country: {
          label: 'Pais',
          options: {
            usa: 'EE. UU.',
          },
        },
      },
    },
    notes: {
      header: 'Notas',
      fields: {
        general: {
          label: 'General',
        },
        driver: {
          label: 'Conductor',
        },
        dispatch: {
          label: 'Expedición',
        },
      },
    },
    complexNotes: {
      header: 'Notas',
      fields: {
        type: {
          label: 'Tipo de nota',
          options: {
            accident: 'Accidente',
            complaint: 'Queja',
            agentIssue: '(QC) Problema con el agente',
            carIssue: '(QC) Problema del vehículo',
            noShow: 'No apareció',
            general: 'Nota general',
            disaptch: 'Nota para enviar',
            driver: 'Nota para el conductor',
            agent: 'Nota del agente',
            cancel: 'Nota de Cancelación',
            booking: 'Nota de reserva',
          },
        },
        value: {
          label: 'Contenido de la nota',
        },
      },
      add: 'Añadir nota',
    },
    preferences: {
      header: 'Preferencias',
      job: {
        header: 'Preferencias de reserva',
        fields: {
          service: {
            label: 'Servicio',
          },
          sharedWith: {
            label: 'Compartido con',
          },
        },
      },
      excludedDrivers: {
        header: 'Conductores Excluidos',
        dualList: {
          driversList: {
            header: 'Lista de Conductores',
          },
          excludedList: {
            header: 'Conductores Excluidos',
          },
        },
      },
      excludedVehicles: {
        header: 'Vehículos Excluidos',
        dualList: {
          vehiclesList: {
            header: 'Lista de Vehículos',
          },
          excludedList: {
            header: 'Vehículos Excluidos',
          },
        },
      },
    },
    jobHistory: {
      header: 'Historial de reservas',
      lastJob: 'Última reserva: {{lastJob}}',
      firstJob: 'Primera reserva: {{firstJob}}',
    },
    contacts: {
      header: 'Contactos',
      fields: {
        name: {
          label: 'Nombre de contacto',
        },
        type: {
          label: 'Tipo de contacto',
          options: {
            sales: 'Vendedor',
            employee: 'Empleado',
          },
        },
        email: {
          label: 'Correo electrónico',
        },
        phone: {
          label: 'NÚMERO DE TELÉFONO',
        },
        fax: {
          label: 'NÚMERO DE FAX',
        },
        address: {
          label: 'Dirección',
        },
        city: {
          label: 'Ciudad',
        },
        state: {
          label: 'Estado',
        },
        zip: {
          label: 'Código postal',
        },
        country: {
          label: 'Pais',
        },
        comment: {
          label: 'Comentario',
        },
      },
      add: 'Añadir contacto',
    },
    rules: {
      header: 'Reglas',
      fields: {
        value: 'Valor',
        discount: {
          label: 'Descuento',
          options: {
            none: 'Ninguno',
            fixed: 'Fijo',
            fixedPP: 'Fijo por pasajero',
            percent: 'Porcentaje',
            percentR: 'Porcentaje (redondeado)',
            percentRU: 'Porcentaje (redondeado)',
          },
        },
        markup: {
          label: 'Marcación',
          options: {
            none: 'Ninguno',
            fixed: 'Fijo',
            fixedPP: 'Fijo por pasajero',
            percent: 'Porcentaje',
            percentR: 'Porcentaje (redondeado)',
            percentRU: 'Porcentaje (redondeado)',
          },
        },
      },
    },
    passengers: {
      header: 'Pasajeros',
      found: 'Se encontraron {{number}} pasajeros',
      linkedTable: {
        title: 'Lista de pasajeros del perfil',
        columns: {
          passenger: 'Pasajero',
          createdAt: 'Fecha de creación',
          vip: 'VIP',
          registerWith: 'Creado en',
          reservations: 'Reservas',
        },
        actions: {
          clear: 'Borrar filtro',
          remove: 'Eliminar pasajero',
        },
      },
      nonLinkedTable: {
        title: 'Lista de pasajeros no vinculados',
        columns: {
          passenger: 'Pasajero',
          registerDate: 'Fecha de creación',
          registerWith: 'Crear en',
          profilesLinked: 'Perfiles vinculados',
          reservations: 'Reservas',
        },
        actions: {
          clear: 'Borrar filtro',
          add: 'Conectar pasajero',
        },
      },
    },
  },
  update: {
    success: {
      content: 'Los cambios se guardaron correctamente.',
    },
    error: {
      content: 'No se pudieron guardar los cambios.',
    },
  },
  create: {
    success: {
      content: 'Su perfil fue creado.',
    },
    error: {
      content: 'No se pudo crear el perfil.',
    },
  },
  delete: {
    deleteBtn: 'Eliminar',
    deleteModal: {
      header: '¿Eliminar perfil?',
      body: 'Está a punto de eliminar {{number}} perfiles',
    },
  },
};

export default profiles;
